"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragOverLayWrapper = void 0;
const core_1 = require("@dnd-kit/core");
const react_1 = __importStar(require("react"));
const documentSidebarBtn_1 = require("./documentSidebarBtn");
const form_element_1 = require("./form_element");
const DragOverLayWrapper = () => {
    var _a, _b, _c, _d, _e, _f;
    const [draggedItem, setDraggedItem] = (0, react_1.useState)(null);
    (0, core_1.useDndMonitor)({
        onDragStart: (e) => {
            setDraggedItem(e.active);
        },
        onDragCancel: (e) => {
            setDraggedItem(null);
        },
        onDragEnd: (e) => {
            setDraggedItem(null);
        },
    });
    if (!draggedItem)
        return null;
    let node = react_1.default.createElement("div", null, "No drag overlay");
    const isDocumentBtnElement = (_b = (_a = draggedItem === null || draggedItem === void 0 ? void 0 : draggedItem.data) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.isDocumentBtnElement;
    const dragType = (_d = (_c = draggedItem === null || draggedItem === void 0 ? void 0 : draggedItem.data) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.dragType;
    if (isDocumentBtnElement && dragType !== "translation") {
        const type = (_f = (_e = draggedItem.data) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.type;
        node = (react_1.default.createElement("div", { id: `${form_element_1.DocumentElements[type].type}_overlay` },
            react_1.default.createElement(documentSidebarBtn_1.DocumentSidebarBtnDragOverLay, { documentElement: form_element_1.DocumentElements[type] })));
    }
    else {
        node = react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(core_1.DragOverlay, null, node);
};
exports.DragOverLayWrapper = DragOverLayWrapper;
